import produce from "immer";
import { CustomizationState } from "../";
import { OptionsConfiguration } from "../../../types/customization/configuration";
import { getCoverDefinitions } from "../../../utils/customization/cover";
import { isBookContent, isCalendarContent } from "../../../utils/customization/format/content";
import { checkAndReplaceInvalidPageDefinitions } from "../../../utils/customization/pageDefinition";

export interface ChangeBookTitleAction {
  type: "changeBookTitle";
  bookTitle: string;
  options: OptionsConfiguration[] | undefined;
}

export function changeBookTitle(
  state: CustomizationState,
  action: ChangeBookTitleAction
): CustomizationState {
  return produce(state, (draftState) => {
    if (!isBookContent(draftState.content) && !isCalendarContent(draftState.content)) {
      return;
    }

    if (action.bookTitle) {
      draftState.content.title = action.bookTitle;

      const coverDefinitions = getCoverDefinitions(draftState.template.pageDefinitions);
      const pageDefinitionKeys = draftState.content.pages.map((page) => page.pageDefinitionKey);

      if (!draftState.content.titleFontKey) {
        let templateFontKey: string | undefined;
        for (const definition of coverDefinitions) {
          if (!pageDefinitionKeys.includes(definition.key)) {
            continue;
          }
          for (const element of definition.elementDefinitions) {
            if (
              element.type === "forced-text" &&
              element.forcedType === "interpolated-content" &&
              element.interpolatedContent === "title"
            ) {
              templateFontKey = element.fontKey;
            }
          }
        }
        if (templateFontKey) {
          draftState.content.titleFontKey = templateFontKey;
        }
      }
    } else if (draftState.content.title) {
      delete draftState.content.title;
    }

    const options = action.options || [];
    checkAndReplaceInvalidPageDefinitions(draftState, options);
  });
}
